/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const featureLandingConfig = {
  featureTitle: null,
  features: [
    {
      icon: 'https://i.ibb.co/vj102pY/rocket.png',
      title: 'Define Perils to be covered',
      description:
        'Working closely with our distribution partners, we define the specific perils to be covered for various markets.',
    },
    {
      icon: 'https://i.ibb.co/vj102pY/rocket.png',
      title: 'Define parameters to measure and triggers',
      description:
        'By looking closely at historical weather patterns, local geographies and risk exposures',
    },
    {
      icon: 'https://i.ibb.co/vj102pY/rocket.png',
      title: 'Define retail product options ',
      description:
        'Based on the perils, parameters and triggers, we package the risk protection.',
    },
    {
      icon: 'https://i.ibb.co/vj102pY/rocket.png',
      title: 'Support entire customer journey via our blockchain platform',
      description:
        'The delivery of the risk management product is supported throughout the entire costumer journey via our blockchain',
    },
  ],
};
